import React, { useState, useEffect } from "react"

export const ChatBotPopup = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [isClosing, setIsClosing] = useState(false)

  // Show popup after a delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 2000) // Show after 2 seconds

    return () => clearTimeout(timer)
  }, [])

  const handleClose = () => {
    // setIsClosing(true)
    // setTimeout(() => {
    //   setIsVisible(false)
    //   setIsClosing(false)
    // }, 300) // Match animation duration
    setIsVisible(false)
    setIsClosing(false)
  }

  if (!isVisible) return null

  return (
    <div className="relative bottom-5 right-0 z-50">
      {/* Speech bubble */}
      <div
        className={` absolute bg-purple-700 text-white px-4 py-3 rounded-2xl shadow-lg cursor-pointer transform transition-all duration-300 ease-in-out ${
          isClosing ? "scale-0 opacity-0" : "scale-100 opacity-100"
        }`}
      >
        {/* Close button */}
        <button
          onClick={(e) => {
            e.stopPropagation()
            handleClose()
          }}
          className="absolute -top-1 -right-1 w-5 h-5 bg-purple-800 text-white rounded-full flex items-center justify-center text-xs hover:bg-purple-900 transition-colors cursor-pointer"
        >
          ×
        </button>

        {/* Text */}
        <span className="text-sm text-nowrap font-medium italic pr-2">
          Chat with Velo
        </span>
        {/* Thought bubble dots */}
        <div className="flex justify-center mt-1 absolute -bottom-2 left-0 right-0">
          <div className="w-6 h-6 bg-purple-700 rounded-full mx-0.5"></div>
          <div className="w-3 h-3 bg-purple-700 rounded-full mx-0.5 relative -bottom-6"></div>
        </div>
      </div>
    </div>
  )
}
